'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DayOfWeekShape = {};

exports.__exports = DayOfWeekShape;
